export default function(fetch: GlobalFetch) {
  return async function() {
    const response = await fetch.fetch(`/api/v2/invoice/create`, {
      method: 'POST',
    })

    const json = await response.json()

    if ('error' in json) {
      throw new Error(json.messages[0])
    }

    return json
  }
}
